// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import * as React from "react";

type Props = {
    placeholder?: string;
    src: string;
    classNames: string;
};

class LazyBackground extends React.Component<Props> {
    state = { src: null };

    componentDidMount() {
        const { src } = this.props;
        if (!src) {
            return;
        }

        const imageLoader = new Image();
        imageLoader.src = src;

        imageLoader.onload = () => {
            this.setState({ src });
        };
    }

    render() {
        if (!this.state.src) {
            return null;
        }

        return (
            <StyledWrapper
                className={this.props.classNames}
                style={{ backgroundImage: `url(${this.state.src || this.props.placeholder})` }}
            ></StyledWrapper>
        );
    }
}

export default LazyBackground;
